const initialState = () => ({
  orderTableOptions: {
    page: 1,
    itemsPerPage: 25,
    totalItems: 0,
    sortBy: ['orderNumber'],
    sortDesc: [true],
  },
  showRightSidebar: false,
  customerOrders: [],
  partnerOrders: [],
  activeTab: 'customer',
  sortedCorporation: [],
  hasMoreData: true,
  activeOrderStatus: '',
  orderRange: {
    start: null,
    end: null,
  },
  processingOrder: false,
  newOrder: {
    orderItems: [],
    customerId: null,
    filters: [],
  },
  nAddress: {},
  allActiveCustomers: [],
  allProducts: [],
  allDiscountCodes: [],
  showActionModal: false,
  actionModalView: false,
  selectedCorporation: 'all',
  selectedCorpId: null,
  partnerCorporation: [],
  selectedOrders: [],
  platformUsers: [],
  requestorId: '',
  loading: true,
  processing: false,
  filterVendorCatalogs: [],
  memberOrdersHeaders: [
    {
      text: 'ORDER NUMBER',
      align: 'start',
      sortable: true,
      filterable: true,
      value: 'orderNumber',
    },
    {
      text: 'ORDER STATUS',
      align: 'start',
      sortable: true,
      filterable: true,
      value: 'status',
    },
    {
      text: 'ORDER DATE',
      align: 'start',
      sortable: true,
      filterable: true,
      value: 'orderDate',
    },
    {
      text: 'SHIP DATE',
      align: 'start',
      sortable: true,
      filterable: true,
      value: 'shipDate',
    },
    {
      text: 'DELIVERY DATE',
      align: 'start',
      sortable: true,
      filterable: true,
      value: 'deliveryDate',
    },
    {
      text: 'TRACKING NUMBER',
      align: 'start',
      sortable: true,
      filterable: true,
      value: 'trackingNumber',
    },
    {
      text: 'NAME/EMAIL',
      align: 'start',
      sortable: true,
      filterable: true,
      value: 'customer.name',
    },
    {
      text: 'VOUCHER',
      align: 'start',
      sortable: false,
      filterable: false,
      value: 'voucherId',
    },
    {
      text: 'TECHNICIAN',
      align: 'left',
      sortable: true,
      filterable: true,
      value: 'technician',
    },
  ],
  sharedHeaders: [
    {
      text: 'Order Number',
      align: 'start',
      sortable: true,
      filterable: true,
      value: 'orderNumber',
    },
    {
      text: 'Order Status',
      align: 'start',
      sortable: true,
      filterable: true,
      value: 'status',
    },
    {
      text: 'Order Date',
      align: 'start',
      sortable: true,
      filterable: true,
      value: 'orderDate',
    },
    {
      text: 'Ship Date',
      align: 'start',
      sortable: true,
      filterable: true,
      value: 'shipDate',
    },
    {
      text: 'Delivery Date',
      align: 'start',
      sortable: true,
      filterable: true,
      value: 'deliveryDate',
    },
  ],
  customerOrderTableHeaders: [
    {
      text: 'Tracking Number',
      align: 'start',
      sortable: true,
      filterable: true,
      value: 'trackingNumber',
    },
    {
      text: 'Name',
      align: 'start',
      sortable: true,
      filterable: true,
      value: 'customer.name',
    },
    {
      text: 'Voucher',
      align: 'start',
      sortable: true,
      filterable: true,
      value: 'voucherId',
    },
    {
      text: '',
      sortable: false,
      filterable: false,
      value: 'data-table-expand',
    },
  ],
  partnerOrderTableHeaders: [
    {
      text: 'Partner',
      align: 'start',
      sortable: true,
      filterable: true,
      value: 'corporation.corporationName',
    },
    {
      text: 'Requested By',
      align: 'start',
      sortable: true,
      filterable: true,
      value: 'requestorId',
    },
    {
      text: '',
      sortable: false,
      filterable: false,
      value: 'data-table-expand',
    },
  ],
  copyOrderFilters: [],
  orderFilters: [
    {
      key: 'techs',
      active: false,
      label: 'All Technicians',
      options: [],
      activeOption: {},
    },
    {
      key: 'orderDate',
      active: false,
      label: 'Order Date',
      options: [
        {
          value: null,
          label: 'Order Date',
        },
      ],
      showOnMain: true,
      showOnAll: false,
      showNavIcon: true,
      activeOption: {},
    },
    {
      key: 'orderTypes',
      active: false,
      label: 'Order Types',
      options: [
        {
          value: 'Hardware',
          label: 'Hardware',
        },
        {
          value: 'Filter',
          label: 'Filter',
        },
        {
          label: 'Other',
          value: 'Other',
        },
      ],
      showOnMain: true,
      showOnAll: true,
      showNavIcon: true,
      activeOption: {},
    },
    {
      key: 'status',
      active: false,
      label: 'Status',
      options: [
        {
          label: 'Open',
          value: 'Open',
        },
        {
          label: 'Payment Pending',
          value: 'Payment Pending',
        },
        {
          label: 'Processing',
          value: 'Processing',
        },
        {
          label: 'Shipped',
          value: 'Shipped',
        },
        {
          label: 'Delivered',
          value: 'Delivered',
        },
        {
          label: 'Do not ship',
          value: 'Do not ship',
        },
        {
          label: 'Sent for shipment',
          value: 'Sent for shipment',
        },
        {
          label: 'Tried to ship',
          value: 'Tried to ship',
        },
        {
          label: 'Error',
          value: 'Error',
        },
        {
          label: 'Ignore',
          value: 'Ignore',
        },
        {
          label: 'Waiting for review',
          value: 'Waiting for review',
        },
      ],
      showOnMain: true,
      showOnAll: true,
      showNavIcon: true,
      activeOption: {},
    },
  ],
  isPilot: false,
  isOpen: true,
  smacOrderFilters: [
    {
      key: 'vendor',
      active: false,
      label: 'Vendor',
      options: [
        {
          label: 'SmartAC',
          value: 'SmartAC',
        },
        {
          label: 'Omni',
          value: 'OMNI',
        },
        {
          label: 'ContractorCommerce',
          value: 'ContractorCommerce',
        },
        {
          label: 'FilterEasy',
          value: 'FilterEasy',
        },
        {
          label: 'FilterKing',
          value: 'FilterKing',
        },
      ],
      showOnMain: true,
      showOnAll: true,
      showNavIcon: true,
      activeOption: {},
    },
    {
      key: 'orderTypes',
      active: false,
      label: 'Order Types',
      options: [
        {
          value: 'Hardware',
          label: 'Hardware',
        },
        {
          value: 'Filter',
          label: 'Filter',
        },
        {
          label: 'Other',
          value: 'Other',
        },
      ],
      showOnMain: true,
      showOnAll: true,
      showNavIcon: true,
      activeOption: {},
    },
    {
      key: 'status',
      active: false,
      label: 'Status',
      options: [
        {
          label: 'Open',
          value: 'Open',
        },
        {
          label: 'Payment Pending',
          value: 'Payment Pending',
        },
        {
          label: 'Processing',
          value: 'Processing',
        },
        {
          label: 'Shipped',
          value: 'Shipped',
        },
        {
          label: 'Delivered',
          value: 'Delivered',
        },
        {
          label: 'Do not ship',
          value: 'Do not ship',
        },
        {
          label: 'Sent for shipment',
          value: 'Sent for shipment',
        },
        {
          label: 'Tried to ship',
          value: 'Tried to ship',
        },
        {
          label: 'Error',
          value: 'Error',
        },
        {
          label: 'Ignore',
          value: 'Ignore',
        },
        {
          label: 'Waiting for review',
          value: 'Waiting for review',
        },
      ],
      showOnMain: true,
      showNavIcon: true,
      activeOption: {},
    },
    {
      key: 'orderDate',
      active: false,
      label: 'Order Date',
      options: [
        {
          value: null,
          label: 'Order Date',
        },
      ],
      showOnMain: true,
      showOnAll: false,
      showNavIcon: true,
      activeOption: {},
    },
  ],
  allHWSkus: [
    {
      label: 'SMBP1G1A1',
      value: 'SMBP1G1A1',
    },
    {
      label: 'SMBP2G1A2',
      value: 'SMBP2G1A2',
    },
    {
      label: 'SMCSG01A1',
      value: 'SMCSG01A1',
    },
    {
      label: 'SMFSG01A1',
      value: 'SMFSG01A1',
    },
    {
      label: 'SMWSG01A1',
      value: 'SMWSG01A1',
    },
    {
      label: 'SMCSG01A2',
      value: 'SMCSG01A2',
    },
    {
      label: 'SMFSG01A2',
      value: 'SMFSG01A2',
    },
    {
      label: 'SMWSG01A2',
      value: 'SMWSG01A2',
    },
  ],
});

export default initialState;
